<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-graduation-cap" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2"  variant="primary" @click="gpath_career_typeAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>

         <iq-card>
          <b-col md="12" class="p-0">
            <iq-card style="width:100%;" >
              <div class="p-0 showFlexListDiv">
                <div class="user-tabing showFlexList">
                  <tab-nav :pills="true" id="pills-tab" class="nav nav-pills d-flex align-items-center justify-content-center profile-feed-items p-0 m-0 w-100">
                    <div  class="flex-fill p-0" @click="switchTabs('allCareers')">
                      <tab-nav-items class="flex-fill p-0" :active="allCareerActive" id="pills-all-careers-tab" href="#profile-all-careers" ariaControls="pills-all-careers" role="tab" :ariaSelected="allCareerActive" title="All Careers" />
                    </div>
                    <div  class="flex-fill p-0" @click="switchTabs('followedCareers')" >
                      <tab-nav-items  class="flex-fill p-0" :active="followingCareerActive" id="pills-following-careers-tab"  href="#profile-following-careers"  ariaControls="pills-following-careers" role="tab" :ariaSelected="followingCareerActive" title="Followed Career" />
                    </div>
                  </tab-nav>
                </div>
              </div>
            </iq-card>
          </b-col>
        </iq-card>

        <div class="iq-card row p-3">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 col-sm-6 col-md-6 col-lg-7 mb-3">
                <b-form-input v-model="vmCarSearch" placeholder="Search" @input="gpath_career_roleList(vmCarSearch)">
                </b-form-input>
              </b-col>
             <b-col class="mb-2 col-12 col-sm-6 col-md-6 col-lg-5">
                <select v-model="whereFilter.name" class="form-control mb-2" @change="setFilters" title="Choose Career name">
                  <option :value="null" disabled>GPaths Career Name</option>
                  <option :value="null">All</option>
                  <option v-for="(item, index) in gpathCareerFiltersList['name']" :key="index" :value="item.name">
                    {{ item.name }}
                  </option>
                </select>
              </b-col>
            </b-row>
          </b-col>
          <b-col v-if="userData.user_role=='USERROLE11111'" class="col-12 col-sm-12 col-md-12 col-lg-2 mb-3 pt-2">
            <CsvDownload :propModuleFile="cvModuleFile" class="Download_button" />
            <CsvUpload :propModulePrefix="cvModulePrefix" class="Download_button"  />
            <VueJsonToCsv :json-data="gpath_careerObjTypeList" csv-title="gpath_careers" v-if="gpath_careerObjTypeList && gpath_careerObjTypeList.length">
              <i class="fa-solid fa-file-csv Download_button"></i>
            </VueJsonToCsv>
          </b-col>
        </div>

        <div class="tab-content">
          <tab-content-item :active="true" id="profile-all-careers" aria-labelled-by="pills-all-careers-tab">
            <div class="row" v-if="gpath_careerObjTypeList && gpath_careerObjTypeList.length > 0" :key="updated">
              <div v-for="(career,index) in gpath_careerObjTypeList" :key="index" class="mt-5 pt-3 col-12 col-sm-6 col-md-4 col-lg-4 px-4">
                <iq-card className="iq-card-block iq-card-stretch iq-card-height" :style="{ borderLeft: '2px solid ' + career.color_code}">
                  <template v-slot:body>
                    <div class="text-left">
                      <div class="badges-icon">
                        <b-avatar class="avatar-70 rounded" v-if="career.image" :style="{ border: '1px solid ' + career.color_code }">
                          <img style="width: 100%;" :src="career.image" alt="career_image">
                        </b-avatar>
                        <b-avatar v-else class="avatar-70 rounded" :text="getFirstLetterOfAString(career.title)" :style="{ border: '3px solid ' + career.color_code, backgroundColor: `${career.color_code} !important`}"></b-avatar>
                        <div class="pull-right right-one">
                          <b-button v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" class="btn btn actionIcon font-size-20 mr-1 btn-secondary btn-sm" title="Edit Career Name" @click="gpath_career_roleEdit(career)"><i class="ri-ball-pen-fill m-0"></i></b-button>
                          <b-button v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" variant="iq-bg-danger actionIcon font-size-20 btn-secondary btn-sm" @click="showGPathCareertypeDeleteDialog(career)" size="sm"><i class="ri-delete-bin-line m-0"></i></b-button>
                          <span class="text-primary pointer" v-if="!isCareerSaved(career.gpct_id)" @click="followCareer($event, career.gpct_id)">Follow</span>
                          <span class="success-color" v-else>Followed</span>
                        </div>
                      </div>
                      <h5 class="mb-2 title twoLineOnly" style="cursor: pointer" :title="career.title" @click="gpath_career_role_detail(career)">
                        {{career.title}}<br>
                        <div class="pull-right pt-4">
                          <b-badge :style="{backgroundColor: `#fff !important`, fontWeight: '400', color: 'var(--iq-title-text)', border: '1px solid ' + career.color_code}">{{career.name}}</b-badge><br>
                        </div>
                      </h5>
                    </div>
                  </template>
                </iq-card>
              </div>
              <div class="col-12">
                <div class="d-flex justify-content-center flex-row flex-fill mb-4" v-if="showLoadMoreBtn && currentPage !== totalPage">
                  <button class="btn btn-primary mb-3" @click="loadMore()">
                    Load More
                  </button>
                </div>
              </div>
            </div>
            <div v-else class="p-2 text-center flex flex-fill justify-content-center">
              We did not find any Careers. Please add Careers.
            </div>
          </tab-content-item>

          <tab-content-item :active="false" id="profile-following-careers" aria-labelled-by="pills-following-careers-tab">
            <b-row class="p-2" v-if="careerFollowObj && careerFollowObj.length > 0" :key="updated">
              <div v-for="(carr, index) in Object.values(careerFollowObj || {})" :key="index" class="mt-5 pt-3 col-12 col-sm-6 col-md-4 col-lg-4 px-4" >
                <iq-card className="iq-card-block iq-card-stretch iq-card-height" :style="{ borderLeft: '2px solid ' + (carr.color_code || '0#3b82f6') }">
                    <template v-slot:body>
                      <div class="text-left">
                        <div class="badges-icon">
                          <b-avatar class="avatar-70 rounded" v-if="carr.car_profile_img" :style="{ border: '1px solid ' + (carr.color_code || '#3b82f6') }">
                            <img style="width: 100%;" :src="carr.car_profile_img" alt="career_follow">
                          </b-avatar>
                          <b-avatar v-else class="avatar-70 rounded" :text="getFirstLetterOfAString(carr.title)" :style="{ border: '3px solid ' + (carr.color_code || '#3b82f6'), backgroundColor: `${carr.color_code || '#3b82f6'} !important` }"></b-avatar>
                          <div class="pull-right right-one">
                            <span class="text-primary pointer" @click="followCareer($event, carr.module_id, 'UNFOLLOW', carr.follow_id)">Unfollow</span>
                          </div>
                        </div>

                        <h5 class="mb-2 title twoLineOnly" style="cursor: pointer" :title="carr.title" @click="goToCareerView(carr.carr_id)" >
                          {{ carr.title }}
                          <div class="pull-right pt-4">
                            <b-badge  :style="{backgroundColor: `#fff !important`, fontWeight: '400', color: 'var(--iq-title-text)', border: '1px solid ' + (carr.color_code || '#3b82f6')}">
                              {{ carr.name }}
                            </b-badge><br>
                          </div>
                        </h5>
                      </div>
                    </template>
                </iq-card>
              </div>
            </b-row>
            <b-row class="p-2" v-else>
              You are not following any Careers. Please follow to see them here.
            </b-row>
          </tab-content-item>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelGPathCareertypeAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <GPathCareerRoleAdd :propOpenedInModal="true" @emitCloseGPathCareertypeAddModal="closeGPathCareertypeAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_typeAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareertypeAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelGPathCareertypeEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <GPathCareerRoleEdit :propOpenedInModal="true" :propGPathCareertypeObj="gpath_career_typeEditObj" @emitCloseGPathCareertypeEditModal="closeGPathCareertypeEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="gpath_career_roleEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeGPathCareertypeEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelGPathCareertypeDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <b-button size="sm" @click="showModelGPathCareertypeDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="gpath_career_typeDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import GPathCareerRoleAdd from "./GPathCareerRoleAdd.vue"
import GPathCareerRoleEdit from "./GPathCareerRoleEdit.vue"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit"
import CsvUpload from "../../../components/Csv/CsvUpload.vue"
import CsvDownload from "../../../components/Csv/CsvDownload.vue"
import { GPathCareerType } from "../../../FackApi/api/GPathCareerType.js"
import { Follows } from "../../../FackApi/api/follow"

export default {
  name: "GPathCareerList",
  components: {
    GPathCareerRoleAdd,
    GPathCareerRoleEdit,
    CsvDownload,
    CsvUpload
  },
  data () {
    return {
      cvModuleFile: "gpath_career_type",
      cvModulePrefix: "GPCT",
      apiName: "gpath_careers_list",
      cvCardTitle: "Careers",
      cvbtnAddNew: "Add",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Career",
      cvAddModalHeader: "Add Career",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Careers",
      showModelGPathCareertypeAdd: false,
      showModelGPathCareertypeEdit: false,
      showModelGPathCareertypeDelete: false,
      sortBy: "name",
      sortDesc: false,
      gpath_careerObjTypeList: [],
      gpath_careerEditObj: null,
      filter: null,
      filterOn: [],
      totalPage: 1,
      currentPage: 1,
      delObj: null,
      showLoadMoreBtn: false,
      gpath_career_typeEditObj: null,
      vmCarSearch: "",
      whereFilter: {
        isAdminPanel: true,
        name: null,
        careerRoleList: 1
      },
      gpathCareerFiltersList: [],
      careerFollowObj: [],
      allCareerActive: true,
      followingCareerActive: false,
      updated: 0
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
  },
  async mounted () {
    socialvue.index()
    await this.gpath_career_filter("name")
    await this.gpathCareerFollowedList()
    this.gpath_career_roleList()
  },
  methods: {
    /**
     * isCareerSaved
     */
    isCareerSaved (gpctId) {
      if (!this.careerFollowObj) {
        return false
      }
      return this.careerFollowObj.some(item => item.module_id == gpctId)
    },
    /**
     * setFilters
    */
    setFilters () {
      this.currentPage = 1
      this.totalPage = 1
      this.gpath_career_roleList()
    },
    /**
     * gpath_career_roleList
     */
    async gpath_career_roleList (searchString = null, loadViaLoadMore = false) {
      try {
        let filter = {}
        if (searchString && searchString.length) {
          filter.searchString = searchString
        }

        if (searchString !== null && !loadViaLoadMore) { // Reset page to 1 when search string changes (and not from load more)
          this.currentPage = 1
        }
        else if (loadViaLoadMore) {
          this.currentPage++
        }
        else {
          if (!this.currentPage) {
            this.currentPage = 1
          }
        }

        let combinedFilter = { ...this.whereFilter, ...filter }
        let gpathCareerRoleListResp = await GPathCareerType.gpath_career_roleList(this, this.currentPage, combinedFilter)

        if (gpathCareerRoleListResp.resp_status) {
          if (gpathCareerRoleListResp.resp_data.currentPage) {
            this.currentPage = parseInt(gpathCareerRoleListResp.resp_data.currentPage)
          }
          if (gpathCareerRoleListResp.resp_data.totalPage) {
            this.totalPage = parseInt(gpathCareerRoleListResp.resp_data.totalPage)
          }

          if (gpathCareerRoleListResp.resp_data.totalCount) {
            this.totalCount = parseInt(gpathCareerRoleListResp.resp_data.totalCount)
          }
          else if (gpathCareerRoleListResp.resp_data.count) {
            this.totalCount = parseInt(gpathCareerRoleListResp.resp_data.count)
          }

          if (this.whereFilter.name || searchString) {
            this.showLoadMoreBtn = false
          }
          else {
            if (this.currentPage >= this.totalPage) {
              this.showLoadMoreBtn = false
            }
            else {
              this.showLoadMoreBtn = true
            }
          }
          const newDataArray = Object.values(gpathCareerRoleListResp.resp_data.data || {})

          // If it's the first page or a new search, replace the data; otherwise, concatenate.
          if (!loadViaLoadMore || this.currentPage === 1) {
            this.gpath_careerObjTypeList = newDataArray
          }
          else {
            this.gpath_careerObjTypeList = this.gpath_careerObjTypeList.concat(newDataArray)
          }
        }
        else {
          this.toastMsg = gpathCareerRoleListResp.resp_msg || "Failed to load career types."
          this.toastVariant = "danger"
          this.showToast = true
          if (this.currentPage === 1 || (searchString !== null && !loadViaLoadMore)) {
            this.gpath_careerObjTypeList = []
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_role_List() and Exception:", err.message)
        this.toastMsg = "An unexpected error occurred while fetching career Role."
        this.toastVariant = "danger"
        this.showToast = true
        this.gpath_careerObjTypeList = []
      }
    },
    /**
     * gpath_career_role_detail
     */
    gpath_career_role_detail (typeName) {
      this.$router.push(`/gpath_career_role_detail/${typeName.gpct_id}`)
    },
    /**
     * gpath_career_typeEdit
     */
    gpath_career_roleEdit (item) {
      try {
        this.gpath_career_typeEditObj = item
        this.showModelGPathCareertypeEdit = true
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_roleEdit() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_typeAdd
     */
    gpath_career_typeAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/gpath_career_role_add")
        }
        else {
          this.showModelGPathCareertypeAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_typeAdd() and Exception:", err.message)
      }
    },
    /**
     * showGPathCareertypeDeleteDialog
     */
    showGPathCareertypeDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelGPathCareertypeDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showGPathCareertypeDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * gpath_career_typeDelete
     */
    async gpath_career_typeDelete () {
      try {
        let gpathCareerTypeDelResp = await GPathCareerType.gpath_career_typeDelete(this, this.delObj.gpct_id)
        await ApiResponse.responseMessageDisplay(this, gpathCareerTypeDelResp)

        if (gpathCareerTypeDelResp && !gpathCareerTypeDelResp) {
          this.showModelGPathCareertypeDelete = false
          return false
        }

        let index = this.gpath_careerObjTypeList.indexOf(this.delObj)
        this.gpath_careerObjTypeList.splice(index, 1)
        this.totalPage = this.totalPage - 1
        this.showModelGPathCareertypeDelete = false
      }
      catch (err) {
        console.error("Exception occurred at gpath_career_typeDelete() and Exception:", err.message)
      }
    },
    /**
     * closeGPathCareertypeAddModal
     */
    closeGPathCareertypeAddModal (gpathCareerTypeAddData) {
      try {
        if (gpathCareerTypeAddData) {
          if (this.gpath_careerObjTypeList && this.gpath_careerObjTypeList.length >= 1) {
            let gpathCareerTypeObjLength = this.gpath_careerObjTypeList.length
            let lastId = this.gpath_careerObjTypeList[gpathCareerTypeObjLength - 1]["id"] || 0
            gpathCareerTypeAddData.id = lastId + 1
          }
          else {
            gpathCareerTypeAddData.id = 11111
          }

          gpathCareerTypeAddData.created_on = moment()
          this.gpath_careerObjTypeList.unshift(gpathCareerTypeAddData)
          this.totalPage = this.totalPage + 1
        }

        this.showModelGPathCareertypeAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closegpath_career_typeAddModal() and Exception:", err.message)
      }
    },
    /**
     * Closes the Edit GPath Career Type modal.
     */
    closeGPathCareertypeEditModal () {
      try {
        this.showModelGPathCareertypeEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeGPathCareertypeEditModal() and Exception:", err.message)
      }
    },
    /**
     * getFirstLetterOfAString
     */
    getFirstLetterOfAString (string) {
      if (string) {
        return string.substr(0, 1)
      }
    },
    /**
     * gpath_career_filter
     */
    async gpath_career_filter (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let gpathCareerFilterResp = await GPathCareerType.gpath_career_filter(this, filterName)
        if (gpathCareerFilterResp) {
          this.gpathCareerFiltersList[filterName] = gpathCareerFilterResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at CustomReport_filter_list_resp() and Exception:", err.message)
      }
    },
    /**
     * loadMore
     */
    loadMore () {
      try {
        if (this.currentPage >= this.totalPage) {
          this.showLoadMoreBtn = false
          return
        }
        this.gpath_career_roleList(null, true)
      }
      catch (err) {
        console.error("Exception occured at loadMore() and Exception", err.message)
      }
    },
    /**
     * switchTabs
     */
    async switchTabs (currentTab) {
      try {
        if (this.allCareerActive && currentTab === "allCareers") {
          return
        }
        else if (this.followingCareerActive && currentTab === "followedCareers") {
          return
        }
        else {
          let currPage = 1
          this.currentPage = currPage
          this.totalPage = ""

          if (currentTab === "allCareers") {
            this.allCareerActive = true
            this.followingCareerActive = false
            await this.gpath_career_roleList()
          }
          else if (currentTab === "followedCareers") {
            this.allCareerActive = false
            this.followingCareerActive = true
            await this.gpathCareerFollowedList()
          }
        }
      }
      catch (err) {
        console.error("Exception occured at switchTabs() and Exception", err.message)
      }
    },
    /**
     *  follow Career ()
     */
    async followCareer (event, moduleId, action = "FOLLOW", follow_id = null) {
      event.stopPropagation()

      if (action == "UNFOLLOW") {
        let payload = {
          module_id: moduleId,
          module_name: "GPATH_CARR",
          follow_id: follow_id
        }

        await Follows.followDelete(this, payload)

        if (this.careerFollowObj && Object.keys(this.careerFollowObj).length == 1) {
          this.careerFollowObj = []
        }
        else {
          delete this.careerFollowObj[moduleId]
        }
      }
      else {
        try {
          let payload = {
            module_id: moduleId,
            module_name: "GPATH_CARR"
          }

          let followResp = await Follows.followAdd(this, payload)
          if (followResp && followResp.resp_status) {
            const careerObj = this.gpath_careerObjTypeList.find(c => c.gpct_id === moduleId)
            if (careerObj) {
              this.careerFollowObj[moduleId] = careerObj
            }
          }
        }
        catch (err) {
          console.error("Exception occured at followCareer() and Exception", err.message)
        }
      }

      this.updated += 1
      this.gpathCareerFollowedList()
    },
    /*
     * gpath Career Followed List
     */
    async gpathCareerFollowedList () {
      try {
        this.whereFilter.module_name = "GPATH_CARR"
        let careersFollowedListResp = await GPathCareerType.gpathCareerFollowedList(this, this.currentPage, this.whereFilter)

        if (careersFollowedListResp && careersFollowedListResp.resp_status) {
          this.careerFollowObj = careersFollowedListResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Exception occurred at gpathCareerFollowedList() and Exception:", err.message)
      }
    }
  }
}
</script>
<style>
  .twoLineOnly{
    width: 100%;
  }
  .badges-icon{
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }
  .right-one{
    position: relative;
    top: 15px;
    text-align: right;
  }
</style>
